import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUpDuoLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.99999 9.37484C9.84005 9.37484 9.67933 9.43509 9.55728 9.55713L3.72395 15.3905C3.47987 15.6345 3.47987 16.0318 3.72395 16.2759C3.96802 16.52 4.36529 16.52 4.60937 16.2759L9.99999 10.8836L15.3906 16.2759C15.6347 16.52 16.032 16.52 16.276 16.2759C16.5201 16.0318 16.5201 15.6345 16.276 15.3905L10.4427 9.55713C10.3207 9.43509 10.1599 9.37484 9.99999 9.37484ZM9.99999 3.5415C9.84005 3.5415 9.67933 3.60176 9.55728 3.7238L3.72395 9.55713C3.47988 9.80121 3.47988 10.1985 3.72395 10.4425C3.96802 10.6866 4.36529 10.6866 4.60937 10.4425L9.99999 5.05029L15.3906 10.4425C15.6347 10.6866 16.032 10.6866 16.276 10.4425C16.5201 10.1985 16.5201 9.80121 16.276 9.55713L10.4427 3.7238C10.3207 3.60176 10.1599 3.5415 9.99999 3.5415Z",
		fill: "currentColor"
	})
});
export default SvgChevronUpDuoLine;
